import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";

import "../../assets/css/chat/chat_main.css";
import ChatListArea from "./components/chatList/ChatList";
import ChattingArea from "./components/chattingArea/ChattingArea";
import ChattingInfo from "./components/chattingInfo/ChattingInfo";
import { responsiveUI, responsiveUI_chatArea } from "../../store/slices/chatUi";
import {
  connectChatSocket,
  disConnectChatSocket,
} from "../../store/slices/chat";
import connectSocket from "../../services/socket/connection";

const App = () => {
  const [clint_width, setClint_width] = useState(window.innerWidth);
  const isSocketConnected = useSelector((state) => state.chat.isConnected);
  const accessToken = JSON.parse(localStorage.getItem("auth_token"))?.access;
  const dispatch = useDispatch();
  const location = useLocation();
  const chatRoomList = useSelector((state) => state.chat.chatRooms?.results);
  const navigate = useNavigate();

  const detectSize = () => {
    setClint_width(window.innerWidth);
  };

  // Connect chat socket
  useEffect(() => {
    if (!isSocketConnected) {
      dispatch(
        connectSocket(
          `/chat/?authorization=${accessToken}`,
          connectChatSocket,
          disConnectChatSocket
        )
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSocketConnected]);

  useEffect(() => {
    window.addEventListener("resize", detectSize);

    clint_width <= 1400
      ? dispatch(responsiveUI(false))
      : dispatch(responsiveUI(true));
    clint_width <= 720
      ? dispatch(responsiveUI_chatArea(false))
      : dispatch(responsiveUI_chatArea(true));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clint_width]);

  const resp_ui_for_userDetails = useSelector(
    (state) => state.chat_ui.responsive_ui
  );
  const resp_ui_for_userList = useSelector(
    (state) => state.chat_ui.responsive_ui_userList
  );
  const resp_ui_for_chatArea = useSelector(
    (state) => state.chat_ui.responsive_ui_chatArea
  );

  useEffect(() => {
    if (location.pathname === "/chat") {
      // Get the first item in the chat room list
      if (chatRoomList && chatRoomList.length > 0) {
        const chatRoomId = chatRoomList[0].channel_id;
        navigate(`/chat/${chatRoomId}`);
      }
    }
  }, [location?.pathname, chatRoomList]);

  return (
    <div className="app">
      {resp_ui_for_userList && <ChatListArea />}

      <Routes>
        <Route
          path="/:channelId"
          element={
            <>
              {resp_ui_for_chatArea && <ChattingArea />}
              {resp_ui_for_userDetails && <ChattingInfo />}
            </>
          }
        />
      </Routes>
    </div>
  );
};

export default App;
